module.exports = __webpack_public_path__ + "img/white.45b8f03f.svg";